export const enum authenticationModeIds {
    None = 0,
    OneTimePassword = 1,
    PushNotification = 2
}
